import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './WithdrawCryptoInstructions.styles';

export const WithdrawCryptoInstructions: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <ol className={classes.list}>
        <li>
          <Typography>Paste your wallet address to the withdraw address field.</Typography>
        </li>
        <li>
          <Typography mb={1}>
            Your withdrawal wallet should be in supported network: <b>Polygon (required)</b>.
          </Typography>
          <ul>
            <li>
              <Typography>
                WARNING: Make sure your wallet is in the supported network. Otherwise funds will be
                lost!
              </Typography>
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            Click withdraw button below to run transaction (it usually takes a few minutes).
          </Typography>
        </li>
      </ol>
    </Box>
  );
};
